import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useStateContext } from "../../../../../../Context/StateContext";

export default function CountryOption({ values, filter }) {
  const [allSkills, setAllSkills,] = useState([]);
  const [selectSkills, setSelectSkills] = useState(null);
  const { state, setCountries } = useStateContext();
  const { countries } = state;

  useEffect(() => {
    setAllSkills(values);
  }, [values]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    const updatedSkills = [...countries, newLanguage];
    setCountries(updatedSkills);
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = countries.filter(
      (language) => language.id !== id
    );
    setCountries(updatedLanguages);
  };

  return (
    <div>
      <ReactSelect
        options={
          Array.isArray(allSkills) &&
          allSkills
            .filter((lang) => {
              return (
                Array.isArray(countries) &&
                !countries.some((selectedLang) => selectedLang.id == lang.id)
              );
            })
            .map((lang) => ({ value: lang.id, label: lang.title }))
        }
        placeholder={`Select ${filter.title}`}
        value={null}
        isClearable={true}
        onChange={(options) => {
          if (options) {
            handleLanguageChange(options);
          }
        }}
      />

      <div className="add-skills">
        {Array.isArray(countries) &&
          countries.map((skills, index) => (
            <div key={index}>
              <p onClick={() => handleDeleteLanguage(skills.id)}>
                {skills.title} <span>x</span>
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
